import React, { useState, useEffect, useContext } from 'react';
import {format} from "date-fns";

import * as net from "../../../lib/net";

import Dd_Sel from "../../../lib/ui/dd_sel";
import Dt_Cal from "../../../lib/ui/dt_cal";
import * as utils from "../../../assets/utils";
import Td_Sel from "../../../lib/ui/td_sel";
import Wnd_Error from "../../../lib/ui/wnd_error";
import Wnd_Ok from "../../../lib/ui/wnd_ok";
import Wnd_Confirm from "../../../lib/ui/wnd_confirm";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Row_Art extends React.Component {
  constructor(props, context) {
    super(props);

    this.dt_fd = React.createRef();
    this.dt_td = React.createRef();
    this.selitems = [
      {fkn: 'sel', text: 'VÄLJ'},
      {fkn: 'show', text: 'VISA'}
    ];

    this.store = props.store;
    this.state = {};
    this.state.ynq = [];
    //this.state.vga = [];
    this.state.rta = [];
    this.state.bra = [];

    this.state.dta = [];
    this.state.ara = [];

    this.state.tot = {};
    this.state.tot.fsg = 0;
    this.state.tot.krubba = 0;

    this.state.ix = 0;
    this.state.faknr = "";
    this.state.datum = "";
    this.state.fdat = "";
    this.state.tdat = "";

      this.state.msg = {};
    this.state.wnds = {};
    this.state.rvo = {};
    if(props.wnds) {
        if(props.wnds.faknr) this.state.faknr = props.wnds.faknr;
    }
      this.state.today = new Date();
      var dts = format(this.state.today, "yyyy-MM-dd");
      this.state.fdat = dts;
      this.state.tdat = dts;
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      this.arts();
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }

  val_pris(val) {
      var s = "";
      if(val == 0) s = "0.00";
      if(val) s = val.cdipris();
      return s;
  };

    wnd_close = () => {
      if(this.props.close) {
          this.props.close(this.props.ctx);
      }
      else this.props.ctx.setState({ wnds: {} });
	};
  tb_style() {
      var css = {};
      css.height = (window.innerHeight * 0.8) - 275;
      css.overflow = "auto";
      return css;
  }
    th_style(id) {
        var css = {};
        css.cursor = "pointer";
        if(id == this.state.sortid) css.color = "#080";
        return css;
    }
    val_save (name, value) {
        //alert(JSON.stringify(name));
        //alert(JSON.stringify(value));
      var rvo = this.state.rvo;
      var na = name.split(".");
      rvo[na[0]][na[1]] = value;
      this.setState({rvo: rvo});
      //setState({[name]: value});
    }
  dt_fdat(e) {
    //alert(JSON.stringify(e));
    var dts = format(e, "yyyy-MM-dd");
    this.setState({ fdat: dts });
  }
  dt_tdat(e) {
      //alert(JSON.stringify(e));
    var dts = format(e, "yyyy-MM-dd");
    this.setState({ tdat: dts });
  }
  oneday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_td.current.updateDt(this.state.fdat);
  }
  addday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_fd.current.updateAdd();
    this.dt_td.current.updateAdd();
  }
  subday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_fd.current.updateSub();
    this.dt_td.current.updateSub();
  }
    arts() {
        var self = this;
        var prm = {};
        prm.req = "fakt.fakt_art.art_list";
        prm.avd = this.state.avd;
        prm.status = "0";

        net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret.rca));

                self.setState({ara: ret.rca }, function () {
                    self.syncTb("artTable");
                });
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
                //gda.wndError(txt);
            });
    }
    syncTb(tb){
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
            tdElements = tbel.getElementsByTagName('td');
        if(tdElements.length < 1 ) return;

        for (let i = 0; i < thElements.length; i++) {
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
                width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
    tb_sort(typ) {
        var self = this;
        var poa = self.state.poa;
        var paa = self.state.paa;
        var sz = this.state.sz_val;

        if(typ == "plu") {
            //paa.sort((a,b) => (a.plu00.p0katnr > b.plu00.p0katnr) ? 1 : ((b.plu00.p0katnr > a.plu00.p0katnr) ? -1 : 0));
        }
        self.setState({paa: paa, sortid: typ });
    }
    sel_row_fkn(row, sel) {
        //alert(JSON.stringify(fkn));
        if(sel.fkn == "sel") {
            this.art_sel(row);
        }
        if(sel.fkn == "show") {
            this.und_show(row);
        }
    }
    art_sel(row) {
        var self = this;
        if(self.props.wnds.cb) {
            self.props.wnds.cb(self.props.ctx, row);
        }
        else self.props.ctx.setState({ wnds: {} });
    }
    und_show(row) {
    }

  render() {
    //if(!this.props.show) return "";

    var title = this.props.title;
    if(!title) title = "Bokning";

	var html =
        <div className="mx_base">
        { this.props.backdrop ? <div className="mx_backdrop" /> : null }
        <div className="m3_dlg mx_70h flex-col" style={ this.dlg_style() }>
        <div className="mx_h01">
            <div>Artiklar : { this.state.faknr }</div>
        </div>

             <div className="divider_green"></div>
       <div className="mx_content flex">

           <div id="artTable" className="flex">
               <table className="table table-bordered table-hover tb " style={{marginBottom: "0px"}}>
                   <thead>
                   <tr>
                       <th style={ this.th_style("artnr") } onClick={() => this.tb_sort("artnr") }>Artnr</th>
                       <th style={ this.th_style("konto") } onClick={() => this.tb_sort("konto") }>Konto</th>
                       <th style={ this.th_style("text") } onClick={() => this.tb_sort("text") }>Text</th>
                       <th style={ this.th_style("pris") } onClick={() => this.tb_sort("pris") }>Pris</th>
                       <th style={ this.th_style("moms") } onClick={() => this.tb_sort("moms") }>Moms</th>
                       <th style={ this.th_style("kredit") } onClick={() => this.tb_sort("kredit") }>Kredit</th>
                       <th></th>
                   </tr>
                   </thead>
               </table>
               <div style={ this.tb_style() }>
                   <table className="table table-bordered table-hover tb" style={{marginBottom:"0px"}}>
                       <tbody>
                       { this.state.ara.map((row, key) =>
                           <tr key={key} onDoubleClick={() => this.art_sel(row) }>
                               <td>{ row.artnr }</td>
                               <td>{ row.konto }</td>
                               <td>{ utils.toLang( row.text ) }</td>
                               <td>{ utils.toPris( row.pris ) }</td>
                               <td>{ row.moms }</td>
                               <td>{ row.kredit }</td>
                               <td>
                                   <Td_Sel items={ this.selitems } getValue={(e)=> this.sel_row_fkn(row, e)} />
                               </td>
                           </tr>
                       )}
                       </tbody>
                   </table>
               </div>
           </div>

            <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <div className="flex"></div>
        </div>
      </div>

        </div>

            <Wnd_Error msg={this.state.msg} ctx={this} />
            <Wnd_Ok msg={this.state.msg} ctx={this} />
            <Wnd_Confirm msg={this.state.msg} ctx={this} />
        </div>
	;
	return html;
  };
}

export default Row_Art;